import React, { Component } from "react"
import { Link } from "gatsby"
import styled from "styled-components";
import Container, { Row, Half, Quarter, ThreeQuarter } from "../../components/layout/container";

import { GatsbyImage } from "gatsby-plugin-image";

const Title = styled.h1`
  font-family: ${(props) => props.theme.fontGreen};
  font-size: 4rem;
  letter-spacing: 0.05rem;
`
const TraderGrid = styled.ul`
  list-style: none;
  padding: 0;
  padding-bottom: 4rem;
  @supports (grid-column-gap: 1rem) {
    display: grid;
    grid-template-columns: 1fr  1fr;
    // grid-auto-columns: repeat(2, 1fr);
    // grid-auto-rows: repeat(3, 1fr);
    grid-column-gap: 15px;
    grid-column-gap: 1rem;
    grid-row-gap: 2rem;

    @media only screen and (max-width: 1100px) {
      grid-template-columns: 1fr 1fr ;
    }

    @media only screen and (max-width: 700px) {
      grid-template-columns: 1fr 1fr;
    }
    
    


    margin: 0;
  }

  display: flex;
  flex-wrap: wrap;
  margin: 0 0 0 -2rem;

  .filterButton {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}

.filterButton button {
  padding: 0.5rem 1rem;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  border-radius: 3px;
  background: #e6e6e6;
  border: none;
  color: #040404;
  text-transform: capitalize;
  cursor: pointer;
}

.filterButton button:hover {
  background: #555;
  color: #fff;
}
`;

// const Background = styled(Img)`
//   // background: #000;
//   // opacity: 0.5;
//   transition: all 0.15s ease-in-out;
//   &:hover {
//     transform: scale(1.015);
//   }
// `;

const Trader = styled.div`
  &#id588fbed5-51fd-5f72-90a1-e26e6eb6c56d {
      display: none;
      visibility: hidden;
  }
  overflow: hidden;
  position: relative;
  @supports (grid-column-gap: 1rem) {
    width: 100%;
    flex: 0;
    margin: 0;
    justify-content: none;
    @media screen and (max-width: ${(props) => props.theme.breakpoints.phone}) {
      flex: 0;
    }
  }
  width: 48%;
  flex: 1 0 30%;
  margin: 0 0rem 2rem 2rem;
  justify-content: space-between;
  @media screen and (max-width: ${(props) => props.theme.breakpoints.phone}) {
    flex: 1 0 50%;
  }
  a {
    text-decoration: none;
  }
  
  h4 {
    margin: 0;
    font-size: 1rem;
    padding-bottom: 0.5rem;
  }
  span {
    display: block;
    font-size: 1rem;
    margin-top: 1rem;
    font-family: ${(props) => props.theme.fontGreen};
    letter-spacing: 0.05rem;
    text-transform: uppercase;
  }
  a {
    font-size: 0.6rem;
    border-bottom: 1px solid ${props => props.theme.colors.primary};
  }
  p {
    display: block;
    font-size: 1rem;
    margin-top: 2px;
    @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
      font-size: 16px;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints.phone}) {
      font-size: 14px;
    }
  }
`;


const Filter = styled.ul`
    position: sticky;
    top: 4rem;
    list-style: none;
    padding: 0;
    margin-top: 9rem;
    span {
            padding-bottom: 1rem;
            display: block;
            text-transform: uppercase;
            font-family: ${(props) => props.theme.fontTurmoil};
            letter-spacing: 1px;
        }
    li {
        cursor: pointer;
        
        .radio {
            width: 18px;
            height: 18px;
            min-width: 18px;
            min-height: 18px;
            border: 2px solid ${props => props.theme.colors.primary};
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 1rem;
            transition: all 0.1s linear;
            .radio-inner-circle {
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background-color: #ffffff;
                transition: all 0.1s linear;
            }
        }
        .category {
            font-size: 1rem;
        }
      display: flex;
      font-family: ${(props) => props.theme.fontCondensed};
      flex-direction: row;
        padding: 0.5rem 0 0.5rem;
        margin-right: 6rem;
      border-bottom: 3px solid ${props => props.theme.colors.primary};
      &.active {
        background: ${props => props.theme.colors.primary};
        color: #fff;
        span:first-of-type {
          color: ${props => props.theme.colors.primary};
        }
      }
    }
  
`



const activeRadioClass = {
  backgroundColor: "#d83142",
}

const getCategories = items => {
  let categoryItems = items.map(item => {
    return item.node.traderCategory
  })
  let uniqueCategories = new Set(categoryItems)
  let categories = Array.from(uniqueCategories)
  categories = ["All", ...categories]
  return categories
}

class TraderMapItems extends Component {
    state = {
        items: this.props.items.allContentfulTrader.edges,
        traderItems: this.props.items.allContentfulTrader.edges,
        categories: getCategories(this.props.items.allContentfulTrader.edges),
        selectedItem: getCategories(this.props.items.allContentfulTrader.edges) && getCategories(this.props.items.allContentfulTrader.edges)[0],
    }
    handleItems = category => {
        if (category === "Services") {
            this.setState({
                traderItems: [...this.state.items],
                selectedItem: category,
            })
        } 
    }
  render() {
    return (
        <React.Fragment>
                <TraderGrid>
                
            
                {this.state.traderItems.map((edge) => (
                  <Trader className="post" id={'id' + edge.node.id} key={edge.node.id}>
                        <Link to={`/trader-directory/${edge.node.slug}/`}>
                          
                            <span>{edge.node.traderNumber}</span>
                            <h4>{edge.node.traderTitle}</h4>
                            <a href={`/trader-directory/${edge.node.slug}/`}>Info &amp; Opening hours</a>
                        </Link>
                    </Trader>
                ))}
                </TraderGrid>
        </React.Fragment>
    )
  }
}

export default TraderMapItems